import { Expose, Type } from 'class-transformer';
import { TimeBlockModel, TimeBlockProjectModel } from '../timeblock/time-block.model';

export class TrackerResponseModel {
  @Expose({ name: 'timeblock' })
  @Type(() => TimeBlockProjectModel)
  public timeBlockModel: TimeBlockModel | null;
  @Expose({ name: 'is_tracker_alive' })
  public isTrackerAlive: boolean;
}
